import React, {useEffect, useRef} from 'react';
import '../../css/Overview.scss';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import { useTranslation } from 'react-i18next';
import { Select } from '../../components/Select';
import { MenuItem } from '@material-ui/core';

export default function Overview({ pages, page, open, onChange, chapters }) {
	const currentPageRef = useRef();
	const firstPageRef = useRef();
	const lastPageRef = useRef();
	const { t } = useTranslation();
	useEffect(() => {
		if (open && currentPageRef?.current) currentPageRef.current.scrollIntoView();
	}, [open, currentPageRef]);

	const getRef = (index) => {
		if (index === page) return currentPageRef;
		if (index === 0) return firstPageRef;
		if (index + 1 === pages.length) return lastPageRef;
	};

	return <div className='overview'>
		<div className='catalog__thumbnails'>
			{
				pages.map((p, index) => {
					const isCurrentPage = index === page;
					return <div
						ref={getRef(index)}
						className={`dot-thumb ${isCurrentPage ? 'active' : ''}`}
						key={index}
						onClick={() => onChange(index + 1)}>
						{open && <img key={p.image} className='carousel__thumbnail__image'src={p.imageMedium} />}
						<div className='dot-thumb-count-holder'>{index + 1} <span>/ {pages.length}</span></div>
					</div>;
				})
			}
		</div>
		<div className='overview-controls'>
			<button onClick={() => firstPageRef.current.scrollIntoView()}><FirstPageIcon /></button>
			<button onClick={() => currentPageRef.current.scrollIntoView()}>{t('currentPage')}</button>
			<button onClick={() => lastPageRef.current.scrollIntoView()}><LastPageIcon /></button>
			{chapters.length > 1 && <Select value={chapters.findLastIndex(c => c.index <= page)} onChange={e => {
				const chapter = chapters[e.target.value];
				if(chapter) {
					onChange(chapter.index + 1);
				}
			}}>
				{chapters.map((chapter, i) => {
					return <MenuItem key={i} value={i}>{chapter.name}</MenuItem>;
				})}
			</Select>}
		</div>
	</div>;
}
